// Latest archived receipt plus a separate explicit version-history action.
// Downloading never requests an updated version of an existing document.
import { Button, Space, Tooltip, type ButtonProps } from 'antd';
import type { PagoClienteResponse } from '@aid/shared';
import { useReceiptActions, type UseReceiptActionsResult } from './ReceiptActions';
import { ReceiptVersionsButton } from './ReceiptVersions';

interface DownloadReceiptButtonProps {
  pago: PagoClienteResponse;
  buttonLabel?: string;
  buttonType?: ButtonProps['type'];
}

interface UseDownloadReceiptResult {
  label: string;
  icon: UseReceiptActionsResult['icon'];
  descargando: boolean;
  descargar: () => Promise<void>;
}

export function useDownloadReceipt(pago: PagoClienteResponse): UseDownloadReceiptResult {
  const { label, icon, isDownloading, download } = useReceiptActions(pago);
  return { label, icon, descargando: isDownloading, descargar: download };
}

export function DownloadReceiptButton({
  pago,
  buttonLabel,
  buttonType,
}: DownloadReceiptButtonProps) {
  const { label, icon, descargando, descargar } = useDownloadReceipt(pago);
  const accessibleLabel = buttonLabel ?? label;

  return (
    <Space size="small">
      <Tooltip title={accessibleLabel}>
        <Button
          type={buttonType ?? 'text'}
          icon={icon}
          loading={descargando}
          aria-label={accessibleLabel}
          onClick={() => void descargar()}
        >
          {buttonLabel}
        </Button>
      </Tooltip>
      <ReceiptVersionsButton idPago={pago.id} compact />
    </Space>
  );
}
